package org.gymly.util

private val EmailRegex = Regex("""^[^\s@]+@[^\s@]+\.[^\s@]+$""")

/** True if blank or a basic email (must include @ and a domain). */
fun String.isValidEmailOrBlank(): Boolean {
    val t = trim()
    return t.isEmpty() || EmailRegex.matches(t)
}

fun String.isValidEmail(): Boolean = trim().isNotEmpty() && EmailRegex.matches(trim())
